import { render, staticRenderFns } from "./update_parc.vue?vue&type=template&id=2c5c278b&scoped=true"
import script from "./update_parc.vue?vue&type=script&lang=js"
export * from "./update_parc.vue?vue&type=script&lang=js"
import style0 from "./update_parc.vue?vue&type=style&index=0&id=2c5c278b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c278b",
  null
  
)

export default component.exports